<!--教室新增-->
<template>
  <div class="edit-area">
    <el-form ref="registerRef"  :model="detailParam" :rules="rules" label-width="140px">
      <el-form-item  label="教室编号:"  prop="classroomCode">
        <el-input style="width: 300px" v-model="detailParam.classroomCode" placeholder=""></el-input>
      </el-form-item>
      <el-form-item  label="教室名称:" prop="classroomName" >
        <el-input style="width: 300px" v-model="detailParam.classroomName" placeholder=""></el-input>
      </el-form-item>

      <el-form-item  label="用途:" prop="usefulness" >
        <el-input style="width: 300px" v-model="detailParam.usefulness"></el-input>
      </el-form-item>
      <el-form-item  label="所在区域:" prop="region" >
        <el-input style="width: 300px" v-model="detailParam.region"></el-input>
      </el-form-item>

      <el-form-item  label="所在楼层:" prop="floor" >
        <el-input style="width: 300px" v-model="detailParam.floor"></el-input>
      </el-form-item>
      <el-form-item  label="可以容纳的学生数:" prop="studentsNumber" >
        <el-input style="width: 300px" v-model="detailParam.studentsNumber"></el-input>
      </el-form-item>

      <el-form-item  label="备注:" >
        <el-input
          type="textarea"
          placeholder=""
          v-model="detailParam.remark"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button  @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOK('registerRef')">确认</el-button>
    </div>
  </div>
</template>
<style>

</style>

<script>
  import globaldata from "../../../../utils/globaldata";
  export default {
    name: 'classroomDetail',
    props: {
      title: {
        msg: ''
      },
      detailParam :{
        id:'',
        shopFrontId:'',
        classroomCode:'',
        classroomName :''  ,
        usefulness : '' ,
        region : '' ,
        floor : '' ,
        studentsNumber : '',
        remark:'',
      },
    },
    data() {
      return {
        //发送短信
        timerSendCodeTip :'发送短信',
        rules:{
          classroomCode:[{required:true,message:"请输入教室编号",trigger:"blur"}],
          classroomName:[{required:true,message:"请输入教室名称",trigger:"blur"}],
        },
      }
    },
    created(){
    },
    mounted() {

    },
    methods: {
      handleOK(registerRef){
        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            this.onClassroom();
          } else {
            return false
          }
        });
      },
      handleCancel(){
        this.$emit('onBtnCancel');
      },
      //创建任务设置
      onClassroom(){
        this.$emit('onClassroom',this.detailParam);

      },

      doUpdatePosition(t,dlg){

      },
      //打开修改弹出框
      handleUpdateOneDlg(row){
        this.visibleDlgUpdate = true;
        let month = [row.startMonth,row.endMonth]
        this.updateParam = {
          id:row.id,
          lessonName:row.lessonName,
          levelName:row.levelName,
          maxLevelName:row.maxLevelName,
          levelVal:row.levelVal,
          maxLevelVal:row.maxLevelVal,
          month:month,
          type:row.type,
          consumeNum:row.consumeNum,
        }
      },
      getStoreWorkersInfo(list){
        console.info(list)
        this.allWorker.push({id:null,name:"无"})
        this.allWorker =this.allWorker.concat(list) ;
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/classroom/components/classroomDetail.vue